"use client"

import * as React from 'react';
import {useContext} from 'react';
import { Basket } from '../../context/basket';
import Button from '@mui/material/Button';
import SwipeableDrawer from '@mui/material/Drawer';
import Item from './renderer/item';
import cart from '../../../../public/static/images/cart.svg';
import account from '../../../../public/static/images/account.svg';
import { useRouter } from 'next/navigation';

export default function Minicart () {
    const { push } = useRouter();
    const data = useContext(Basket);
    const [state, setState] = React.useState({
        right: false
    });

    let basketCount = 0;
    const basketItems = data?.data?.quote?.quote?.items.map((item) => {
        if (item.month_data !== null && item.is_component === false) {
            basketCount++;
        }
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const loadBasket = () => {
        push('/basket');
    }

    const loadAccount = () => {
        push('/account');
    }

    return <React.Fragment key={'right'}>
        <img className="account-icon hide margin-left" src={account.src} height="25" alt="account" onClick={() => loadAccount()} />
        {/*<div className="minicart-header-container padding-left">*/}
        {/*    <img onClick={toggleDrawer('right', true)} src={cart.src} height="25" alt="cart"/>*/}
        {/*    <span className="basket-count">{basketCount}</span>*/}
        {/*</div>*/}
        <a href="/basket">
            <div className="minicart-header-container padding-left">
                <img src={cart.src} height="26" alt="cart"/>
                <span className="basket-count">{basketCount}</span>
            </div>
        </a>

        <SwipeableDrawer
            anchor={'right'}
            open={state['right']}
            onClose={toggleDrawer('right', false)}
            key={'swipeable-drawer'}
        >
            <div className="minicart-wrapper">
                <div className="minicart-container">
                    <div className="minicart-header">
                        <div className="minicart-header-title">
                            <h3 className="minicart-header-title-text">Basket</h3>
                        </div>
                        <div className="minicart-header-close">
                            <a
                                className="minicart-header-close-button cross-button"
                                title="Close"
                                onClick={toggleDrawer('right', false)}
                            >X</a>
                        </div>
                    </div>
                    <div className="minicart-body">
                        <div className="minicart-body-content">
                            {data === null && (
                                <p className="cart-empty">Loading.</p>
                            )}
                            {data !== null && typeof data?.data?.quote?.quote !== undefined
                                && data?.data?.quote?.quote?.items.length === 0 && (
                                <p className="cart-empty">No products in the cart.</p>
                            )}
                            {data !== null && typeof data?.data?.quote?.quote !== undefined
                                && data?.data?.quote?.quote?.items.length > 0 && (
                                    <div className="minicart-item-wrapper">
                                        <div className="minicart-item-container">
                                            {data.data.quote.quote.items.map((item, index) => (
                                                <div className="item-wrapper" key={'basket-item-div-' + index}>
                                                    {item.month_data !== null && item.is_component === false && (
                                                        <Item key={'item-' + index} item={item}/>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                        <div className="basket-button-wrapper">
                                            <button variant="contained" color="primary" className="button"
                                                    onClick={() => loadBasket()}>
                                                <span className="basket-button-text">Go to basket</span>
                                            </button>
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </SwipeableDrawer>
    </React.Fragment>;
}